import React from 'react'

const Logotype = props =>
//  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 800 600" enable-background="new 0 0 800 600" xml:space="preserve">
  <svg { ...props } version="1.1" id="Logotype" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 800 350" enableBackground="new 0 0 800 450" xmlSpace="preserve">
    <text transform="matrix(1 0 0 1 257.0295 229.417)" fontFamily="'BodoniFLF-Roman'" fontSize="91" letterSpacing="22">SAGA</text>
    <rect x="174" y="270.5" width="452" height="3.3"/>
    <text transform="matrix(1 0 0 1 304.1572 325.5)" fontFamily="'Montserrat-ExtraLight'" fontSize="16.8" letterSpacing="4">HÅR &amp; SKÖNHET</text>
  </svg>

export default Logotype
